/**
 * Noop is a function that does nothing.
 */
const noop = () => {}

export default noop
